import { SnapshotIn, types } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import React from 'react';

export const BlankV2UserAnswer = types
  .model('BlankV2UserAnswer', {
    id: types.identifier,
    userAnswer: types.maybeNull(types.string),
    isCorrect: types.maybeNull(types.boolean),
  })
  .actions((self) => ({
    setUserAnswer(userAnswer: string) {
      self.userAnswer = userAnswer;
    },
  }));

export interface BlankSnapshotIn extends SnapshotIn<typeof BlankV2UserAnswer> {}

export const BlankV2DoTestStore = types
  .model('BlankV2DoTestStore', {
    userAnswers: types.map(BlankV2UserAnswer),
    isViewResult: false,
  })
  .actions((self) => ({
    setUserAnswers(userAnswers) {
      self.userAnswers.replace(userAnswers);
    },
    update(blank: BlankSnapshotIn) {
      if (self.userAnswers.has(blank.id)) {
        self.userAnswers.get(blank.id).setUserAnswer(blank.userAnswer);
      } else {
        self.userAnswers.put(blank);
      }
    },
    retry() {
      self.isViewResult = false;
      self.userAnswers.clear();
    },
    viewResult() {
      self.isViewResult = true;
    },
  }))
  .views((self) => ({
    preparePayload() {
      const userAnswers = [];

      self.userAnswers.forEach(({ id, userAnswer }) => {
        userAnswers.push({ questionid: id, answer: userAnswer });
      });

      return userAnswers;
    },
  }));

export const useBlankV2DoTestStore = () => useStore(BlankV2DoTestStore);

export const withBlankV2DoTestStore = (Component) => (props) => {
  const Provider = useProvider(BlankV2DoTestStore);
  const store = useCreateStore(BlankV2DoTestStore, {});

  return (
    <Provider value={store}>
      <Component {...props} />
    </Provider>
  );
};
